import React, { useState, useRef } from 'react';
import './DigitalPriceTag.css';
import Button from '../../components/button';
import CustomInput from '../../components/customInput/CustomInput';

function AddUpload({ title, onCancel, handleUpload, uploadErr, handleUploadErr }) {
  const [currentFileUpload, setCurrentFileUpload] = useState();
  const [showPlaceholder, setShowPlaceholder] = useState(true);
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    let file = event.target.files[0];
    handleUploadErr('');
    setCurrentFileUpload(file);
    setShowPlaceholder(false);
  };

  return (
    <div className="manage-user-container">
      <div style={{ width: '650px', padding: '30px' }}>
        <div style={{ fontSize: '24px', fontWeight: '400' }}>{title}</div>

        <div style={{ alignItems: 'center', marginTop: '20px' }}>
          <div>Upload Discounted RRP Excel</div>
        </div>

        <div style={{ display: 'flex', marginTop: '20px' }}>
          <div className="relative">
            <input
              type="file"
              accept=".xlsx, .xls"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />

            <div className="relative">
              <CustomInput
                style={{ width: '350px', height: '50px' }}
                value={currentFileUpload ? currentFileUpload.name : ''}
                disabled={true}
                onChange={() => { }}
              />

              {showPlaceholder && (
                <div className="custom-placeholder">Select a file to upload</div>
              )}
            </div>
          </div>

          <div style={{ marginLeft: 'auto', display: 'flex' }}>
            <Button onClick={() => fileInputRef.current.click()} className='upload-btn' style={{ marginLeft: '100px' }}>BROWSE</Button>
          </div>
        </div>

        <div style={{ display: 'flex', marginTop: '20px' }}>
          <div>Note: Maximum upload file size is 4 GB</div>
        </div>

        <div style={{ display: 'flex', marginTop: '20px' }}>
          <div><p className="text-danger mt-2">{uploadErr}</p></div>
        </div>

        <div className="footer">
          <Button className='upload-btn' style={{ marginRight: '10px' }} onClick={() => handleUpload(currentFileUpload)} >SUBMIT</Button>
          <Button className='upload-btn' style={{ marginRight: '10px' }} onClick={onCancel} >CANCEL</Button>
        </div>

      </div>
    </div>
  );
}

export default AddUpload;